var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36163_74884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.41833C0 4.44777 4.02944 0.418335 9 0.418335V0.418335C13.9706 0.418335 18 4.44777 18 9.41833V9.41833C18 14.3889 13.9706 18.4183 9 18.4183V18.4183C4.02944 18.4183 0 14.3889 0 9.41833V9.41833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.918335,
    width: 17,
    height: 17,
    fill: "#5551FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_36163_74884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 9.94958L7.75625 12.4808L12.35 7.41833",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.918335,
    width: 17,
    height: 17,
    stroke: "#EBEBEB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.4183C4.58172 17.4183 1 13.8366 1 9.41833H-1C-1 14.9412 3.47715 19.4183 9 19.4183V17.4183ZM17 9.41833C17 13.8366 13.4183 17.4183 9 17.4183V19.4183C14.5228 19.4183 19 14.9412 19 9.41833H17ZM9 1.41833C13.4183 1.41833 17 5.00006 17 9.41833H19C19 3.89549 14.5228 -0.581665 9 -0.581665V1.41833ZM9 -0.581665C3.47715 -0.581665 -1 3.89549 -1 9.41833H1C1 5.00006 4.58172 1.41833 9 1.41833V-0.581665Z",
    fill: "#EBEBEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36163_74884"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.41833C0 4.44777 4.02944 0.418335 9 0.418335V0.418335C13.9706 0.418335 18 4.44777 18 9.41833V9.41833C18 14.3889 13.9706 18.4183 9 18.4183V18.4183C4.02944 18.4183 0 14.3889 0 9.41833V9.41833Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_36163_74884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 6.75,
    fill: "white",
    transform: "translate(4.5 6.04333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOn);
export default __webpack_public_path__ + "static/media/check-on.b82e7f07222efdc7f9f26723fedfe0e9.svg";
export { ForwardRef as ReactComponent };